import React from "react";
import { ProfileTabConfig } from "../../../types/config";
import ProductDetailsTab from "../ProductDetailsTab";
import ProductItemList from "../ProductItemList";
import { Product, ProductItemListProps } from "../types/products";

export interface ProductTabsConfigOptions {
  itemListProps?: Pick<
    ProductItemListProps,
    "statusFilter" | "onStatusFilterChange"
  >;
}

export const ProductTabsConfig = (
  product: Product,
  options?: ProductTabsConfigOptions
): ProfileTabConfig[] => {
  return [
    {
      id: 0,
      labelKey: "product-details-tab",
      defaultLabel: "Details",
      ariaControls: "product-details-tabpanel-0",
      content: <ProductDetailsTab product={product} />
    },
    {
      id: 1,
      labelKey: "product-items-tab",
      defaultLabel: "Product Items",
      ariaControls: "product-items-tabpanel-1",
      content: <ProductItemList product={product} {...options?.itemListProps} />
    }
  ];
};
